import { Component, Inject, Input, OnInit } from "@angular/core";
import { VisualizationOptionsType } from "@arch/_shared/types/options-visualization";
import {
    CompanyEntity,
    PointEntity,
    SerieEntity,
    VisualizationEntity,
} from "@arch/domain/entity";
import { HighchartsRenderComponent } from "../../highcharts-render/highcharts-render.component";
import { FlexLayoutModule } from "@angular/flex-layout";
import { SharedDsnModule } from "@app/shared/modules/shared-dsn.module";
import { ChartHistoricComponent } from "../../chart-historic/chart-historic.component";
import { GetSeriesByIdsController } from "@arch/presentation/controllers";
import { FormatNumbers } from "@arch/_shared/utils/format-number.utils";
import { MatTooltipModule } from "@angular/material/tooltip";

@Component({
    selector: "app-special-chart-coins",
    imports: [
        FlexLayoutModule,
        SharedDsnModule,
        ChartHistoricComponent,
        MatTooltipModule,
    ],
    templateUrl: "./special-chart-coins.component.html",
    styleUrl: "./special-chart-coins.component.scss",
})
export class SpecialChartCoinsComponent implements OnInit {
    @Input() visualization!: VisualizationEntity;
    @Input() options!: VisualizationOptionsType;
    @Input() series!: SerieEntity[];
    @Input() company!: CompanyEntity;
    @Input() points!: PointEntity[];

    public newPoints: PointEntity[];
    public newSeries: SerieEntity[];
    public obligations: ConfigLabelType = null;
    public available: ConfigLabelType = null;
    public liquidity: number;
    public coinsLength: number[] = [];

    constructor(readonly getSeriesByIdsController: GetSeriesByIdsController) {}

    ngOnInit(): void {
        this.setDataStructure();
    }

    private setDataStructure(): void {
        this.visualization.setChartHistoricCategoryVisualization("line");
        const historicSeriesId = this.visualization.props.historic.map((s) => {
            return s.dataSerieId;
        });

        const series = this.getSeriesByIdsController.execute(historicSeriesId);

        const points: PointEntity[] = this.points.filter(
            (p: PointEntity) => p.props.s === series[0].props._id
        );

        const _getLastPoint = (pointId: string) => {
            const point = this.points
                .filter((p) => p.props.s === pointId)
                .reverse()[0];

            return FormatNumbers.byUnit("currency", point.props.m.v, 2);
        };

        const obligationsConfigId =
            this.visualization.props.component?.configs?.label?._id;
        const coinsConfigId =
            this.visualization.props.component?.configs?.coins?._id;
        const fixedCoinsId =
            this.visualization.props.component?.configs?.fixedCoins?._id;

        this.liquidity = this.points
            .filter((p) => p.props.s === coinsConfigId)
            .reverse()[0].props.m.v;
        this.obligations = {
            v: _getLastPoint(fixedCoinsId),
            name: this.series.find((p) => p.props._id === fixedCoinsId).props
                .name,
        };
        this.available = {
            v: _getLastPoint(obligationsConfigId),
            name: this.series.find((p) => p.props._id === obligationsConfigId)
                .props.name,
        };
        this.coinsLength = new Array(Math.ceil(6));

        if (this.options.goals) {
            const DISPONIVEL = "n8w6onwcqt1xiacwoyxoe";
            const seriesGoals = this.series.find(
                (s) => s.props.referenceId == DISPONIVEL
            );
            this.series.push(seriesGoals);
            const goalsPoints = this.points.filter(
                (p) => p.props.s === seriesGoals.props._id
            );
            points.push(...goalsPoints);
        }

        this.newPoints = points;
        this.newSeries = series;
    }
}

export interface ISpecialChartCoins {
    series: SerieEntity[];
    points: PointEntity[];
    visualization: VisualizationEntity;
    options: VisualizationOptionsType;
    company?: CompanyEntity;
}

type ConfigLabelType = {
    v: string;
    name: string;
};
